import Dialog from '@mui/material/Dialog';
import React from 'react';
import { HabitScheduleForm } from 'shared/components/ui/habit-schedule-form';

export type HabitScheduleDialogProps = React.ComponentProps<
  typeof HabitScheduleForm
> & {
  open: boolean;
};

export const HabitScheduleDialog: React.FC<HabitScheduleDialogProps> = ({
  open,
  onCancel,
  ...rest
}) => (
  <Dialog open={open} onClose={onCancel}>
    <HabitScheduleForm onCancel={onCancel} {...rest} />
  </Dialog>
);
